import { render, staticRenderFns } from "./WhyXiyue.vue?vue&type=template&id=a27b5240&scoped=true"
import script from "./WhyXiyue.vue?vue&type=script&lang=js"
export * from "./WhyXiyue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27b5240",
  null
  
)

export default component.exports